import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

let searchTimeout = null;

export const useFrameworkAgreementsListStore = create(
    persist(
        (set, get) => ({
            order: null,
            offset: 0,
            page: 1,
            selectedStatus: [],
            selectedManager: [],
            search: null,
            setOrder: (value) => set({ order: value }),
            setPage: (value) => set({
                page: value,
                offset: value - 1,
            }),
            setSelectedStatus: (value) => set({ selectedStatus: value }),
            setSelectedManager: (value) => set({ selectedManager: value }),
            setSearch: (value) => set({ search: value }),
            handleSearch: async () => {

                const searchValue = document.getElementById('global_search').value;

                if (searchValue.length == 0 || searchValue.length > 2) {
                    if (searchTimeout != null) clearTimeout(searchTimeout);
                    searchTimeout = setTimeout(() => {
                        set({ search: searchValue });
                    }, 500);
                }
                else if (searchValue.length == 0) {
                    set({ search: null });
                } // endif

            },
        }),
        {
            name: 'framework-agreements-list',
            storage: createJSONStorage(() => localStorage),
        },
    ),
);
